// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment, REGEX } from '@ebeihilfe/core';

export const environment: Environment = {
  production: true,
  debugLevel: 'info',
  passwordRules: {
    minLength: 8,
    hitPointPerRule: 10,
    minHitPoints: 30,
    rules: [
      {
        name: 'small',
        pattern: REGEX.HAS_LOWERCASE,
        text: 'passwort_meter.rule_description.case_small',
      },
      {
        name: 'big',
        pattern: REGEX.HAS_UPPERCASE,
        text: 'passwort_meter.rule_description.case_big',
      },
      {
        name: 'numbers',
        pattern: REGEX.HAS_NUMBER,
        text: 'passwort_meter.rule_description.numbers',
      },
      {
        name: 'special',
        pattern: REGEX.HAS_SPECIAL,
        text: 'passwort_meter.rule_description.special',
      },
    ],
  },
  authentication: {
    grants: ['password'],
  },
  request: {
    hasCustomRequestStates: false,
    hasCustomRequestType: false,
  },
  sentry: {
    dsn: 'https://19bbdb5d749d68697f08784aabf846d2@o4508767103352832.ingest.de.sentry.io/4508772111155280',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 0.3,
  },
  customizing: {
    allowUserSelfDelete: true,
    hasUnfinishedAntrage: true,
    hasBescheide: true,
    hasUebersicht: true,
    ionic: {
      dashboard: {},
      scanbot: {
        documentScannerConfig: {
          primaryColor: '#005E90',
          secondaryColor: '#F2B700',
        },
        shouldBinarize: true,
        filter: 'PURE_BINARIZED',
      },
    },
    health: { timeout: 2000 },
  },
  pinConfiguration: {
    storage: 'session',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
